export default {
  namespaced: true,
  state: {
    videoBase64: '', // 视频
    userName: '', // 姓名
    idCardNo: '', // 身份证号
  },
  mutations: {
    initInfo(state) {
      state.videoBase64 = ''
      state.userName = ''
      state.idCardNo = ''
    },
    setInfo(state, payload) {
      const { userName, idCardNo } = payload
      state.userName = userName
      state.idCardNo = idCardNo
    },
    setVideoBase64(state, payload) {
      const { videoBase64 } = payload
      state.videoBase64 = videoBase64
    },
  },
  actions: {},
}
